<template>
  <div class="login-container">
    
    <el-form ref="formRef" :model="form" :rules="rules" class="login-form">
      <h3 class="title">题海灯塔小程序管理系统</h3>
      <el-form-item prop="username">
        <el-input v-model="form.username" size="large" placeholder="请输入用户名" prefix-icon="User"/>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="form.password" size="large" placeholder="请输入密码" show-password prefix-icon="Lock" />
      </el-form-item>
      <el-form-item>
        <el-button  type="primary"  @click="handleSubmit" class="submit-btn"> 登录</el-button>
      </el-form-item>
      <el-button type="primary" @click="showWeChatLogin = true">微信扫码登录</el-button>
      <span class="register-link" @click="navigateToRegister">没账号？去注册</span>
    </el-form>
    <WeChatLogin 
      v-model:visible="showWeChatLogin"
      @login-success="handleWeChatLoginSuccess"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { LoginApi, userInfoApi } from "@/api/admin";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { useStore } from "@/store/user";
import WeChatLogin from './WeChatLogin.vue'



const router = useRouter();

const formRef = ref<FormInstance>();

const userStore = useStore();

const showWeChatLogin = ref(false)

const form = reactive({
  username: "",
  password: "",
});

const rules = reactive<FormRules<typeof form>>({
  username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    { min: 6, max: 15, message: "密码长度6-15位", trigger: "blur" }
  ],
});

const handleSubmit = async () => {
  if (!formRef.value) return;
  
  try {
    await formRef.value.validate();
    const res = await LoginApi(form);
    
    if (res.success) {
      localStorage.setItem("token", res.data.token);
      
      // 获取完整用户信息
      const userRes = await userInfoApi();

      const info =userRes.data.userInfo;
      if (userRes.code === 20000) {
        console.log("登录成功111",userRes)

        userStore.setUserInfo({
          username: info.username,  
          role: info.role,
          avatar: info.avatar 
        });
      }
      
      router.push("/index");
      ElMessage.success("登录成功");
    }
  } catch (error) {
    console.error('登录失败:', error);
    ElMessage.error("登录失败，请检查凭证");
  }
};

const handleWeChatLoginSuccess = (userInfo: any) => {
  // 处理微信登录成功后的逻辑
  userStore.setUserInfo({
    username: userInfo.nickname,
    role: 'user', // 根据实际情况设置角色
    avatar: userInfo.avatar
  });
  
  router.push('/index');
  ElMessage.success('微信登录成功');
}

const navigateToRegister = () => router.push("/register");

</script>


<style lang="less" scoped>
.login-container {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;
  display: flex;
  align-items: center;
  justify-content: center;


  
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.login-form {
  width: 450px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  position: relative;
  animation: slideUp 0.6s ease;
}

.title {
  color: #2c3e50;
  font-size: 28px;
  text-align: center;
  margin-bottom: 40px;
}

:deep(.el-input__inner) {
  height: 52px;
  padding-left: 48px !important;
}

.submit-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
}

.register-link {
  display: block;
  text-align: center;
  margin-top: 20px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #409EFF;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
